import toDate from './to-date';
import normalizeSpaces from '@dubbletrack/toolbox/utils/normalize-spaces';
import formatISO from 'date-fns/formatISO';
import { format as dateFnFormat } from 'date-fns-tz';
export default function formatToTimeZone(dirtyDate, fmtString, dirtyOptions) {
  let { timeZone, ...options } = dirtyOptions || {};
  var zonedDate = toDate(new Date(dirtyDate), { timeZone: timeZone });

  if (fmtString == 'iso8601') {
    return formatISO(zonedDate);
  } else if (typeof fmtString === 'string') {
    let formattedDate = dateFnFormat(zonedDate, fmtString);

    return formattedDate;
  } else if (typeof fmtString === 'object') {
    let formattedDate = new Intl.DateTimeFormat(
      options.locale,
      fmtString,
    ).format(zonedDate);

    if (options.lowercase || options.lowerCase || options.lower) {
      return normalizeSpaces(formattedDate.toLowerCase());
    } else {
      return normalizeSpaces(formattedDate);
    }
  }
}
